import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const ClassSelectionSubjectReadSlice = createSlice({
  name: "ClassSelectionSubjectReadSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    ClassSelectionSubjectRead: (state) => {
      state.isLoading = true;
    },
    successClassSelectionSubjectRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureClassSelectionSubjectRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearClassSelectionSubjectRead: (state) => {
      state.data = {};
    },
  },
});

export const {
  ClassSelectionSubjectRead,
  failureClassSelectionSubjectRead,
  successClassSelectionSubjectRead,
  clearClassSelectionSubjectRead,
} = ClassSelectionSubjectReadSlice.actions;

export default ClassSelectionSubjectReadSlice.reducer;
